import returnDiscountedAmount from './returnDiscountedAmount';
import returnDiscount from "../helper_functions/returnDiscount";


export function calculateMaterialCost(materialList) {
    let totalCost = 0;
    materialList.data.forEach(mat => { totalCost += +returnDiscountedAmount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    return Number(totalCost)

}

export function calculateBundleCost(serviceBundle) {
    let totalCost = 0;
    serviceBundle.data.forEach(bundle => { totalCost += +returnDiscountedAmount({ cost: bundle.cost, discount: bundle.discount, discountType: bundle.discountType }) });
    return Number(totalCost)
}

export function calculateServiceCost(serviceList) {
    let totalCost = 0;
    serviceList.data.forEach(service => service.costType === 'Fixed' && (totalCost += +returnDiscountedAmount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
    return Number(totalCost)
}

export function calculateTotalTechnicianCost(serviceList, materialList, otherList, technicianCost) {
    let totalMinutes = 0;
    serviceList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    materialList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    otherList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    const result = (totalMinutes / 60)
    const totalTechnicianCost = (result * technicianCost).toFixed(2)
    return Number(totalTechnicianCost);
}

export function calculateTotalTax(materialList, fromatedTaxRate) {
    const totalCost = Number(calculateMaterialCost(materialList));
    const tax = totalCost * fromatedTaxRate;
    return Number(tax.toFixed(2));
}

export function calculateTotalCost(serviceList, materialList, otherList, serviceBundle, technicianCost, fromatedTaxRate) {
    const totalCost = calculateTotalTechnicianCost(serviceList, materialList, otherList, technicianCost) + calculateMaterialCost(materialList) + calculateBundleCost(serviceBundle) + calculateServiceCost(serviceList);
    return Number(totalCost.toFixed(2));
}

export function calculateTotalFinalCost(totalCost, tax) {
    const total = (tax + totalCost).toFixed(2)
    return Number(total)
}

export function calculateTotalDiscount(materialList, serviceList, serviceBundle) {
    let totalMaterialDiscount = 0;
    materialList.data.forEach(mat => { totalMaterialDiscount += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    let totalServiceListDiscount = 0;
    serviceList.data.forEach(service => service.costType === 'Fixed' && (totalServiceListDiscount += +returnDiscount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
    let totalServiceBundleDiscount = 0;
    serviceBundle.data.forEach(mat => { totalServiceBundleDiscount += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    const totalDiscount = Number(totalMaterialDiscount) + Number(totalServiceListDiscount) + Number(totalServiceBundleDiscount);
    return totalDiscount;
}


